import useModal from '@/@core/components/base-modal/hooks/useModal'
import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import inventoryListModel from '@/models/inventory/inventory-list'
import store from '@/store'
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable'
import usePagination from '@/views/components/pagination/usePagination'
import {
  onBeforeMount, reactive, ref, watch,
} from '@vue/composition-api'

import usePermissionByAccount from "@/constants/navigation/BOYNYKJMS2EH/permission-by-account"

export default function useInventoryPrivilegeList() {
  const { getPermissionModule } = usePermissionByAccount()
  const { openDefaultErrorModal, openErrorModal } = useValidationModal()
  const { fetchInventoryList: fetchInventoryListModel } = inventoryListModel()
  const { openModal, closeModal } = useModal()
  const { pagination, onPageChange, onFilterEntity } = usePagination()
  const { filters, ordering, onSetValueSearch } = useFilterHeaderTable()

  const isDefaultInList = ref(false)

  const loading = reactive({
    tableData: false,
  })

  const fields = [
    { key: 'seq', label: 'No.' },
    { key: 'name', label: 'Inventory Name' },
    { key: 'detail', label: 'Detail' },
    { key: 'alt_reference', label: 'Reference' },
    { key: 'actions', label: '' },
  ]
  
  const modalPopup = reactive({
    report: false,
  });

  const onOpenExportModal = () => {
    modalPopup.report = true;
    openModal();
  };

  const closeReportModal = () => {
    modalPopup.report = false;
    closeModal();
  };
  const inventoryTable = reactive({
    payload: [],
  })

  const modalType = reactive({
    createInventory: false,
  })

  const onCloseModalInventory = () => {
    closeModal()
    modalType.createInventory = false
  }

  const onOpenModalCreateInventory = () => {
    modalType.createInventory = true
    openModal()
  }

  const fetchInventoryList = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true
    }
    fetchInventoryListModel.payload.Page = pagination.currentPage
    fetchInventoryListModel.payload.Limit = pagination.perPage
    fetchInventoryListModel.payload.Filters = filters
    fetchInventoryListModel.payload.Ordering = ordering.value
    store
      .dispatch('api/apiRequest', fetchInventoryListModel)
      .then(response => {
        inventoryTable.payload = response.data.payload
        pagination.rows = response.data.payload.length
        pagination.totalRows = response.data.filtered_record
        const defaultMaster = response.data.payload.filter(o => o.isdefault == true).length > 0
        isDefaultInList.value = defaultMaster
      })
      .catch(error => {
        openDefaultErrorModal(error)
      })
      .finally(() => {
        loading.tableData = false
      })
  }

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchInventoryList()
      }
    },
    { deep: true },
  )

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1

      fetchInventoryList()
    },
    { deep: true },
  )

  onBeforeMount(() => {
    fetchInventoryList()
  })

  return {
    isDefaultInList,
    pagination,
    fields,
    loading,
    inventoryTable,
    modalType,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onCloseModalInventory,
    onOpenModalCreateInventory,
    modalPopup,
    onOpenExportModal,
    closeReportModal,
    getPermissionModule
  }
}
